/* eslint-disable i18next/no-literal-string */
import {Table} from '@dropbox/dig-components/table';
import {Text} from '@dropbox/dig-components/typography';
import type {AskHealthVersion} from 'client';
import {Link} from 'components/DSYS/Link';

import styles from './AskHealth.module.css';
import {percent, seconds, shortDate} from './format';
import {offlineQuality} from './versions';

const round = (value: number | null) => (value == null ? '—' : `${Math.round(value)}`);

const HEADERS = [
  'Version',
  'What changed',
  'Quality',
  'Live judge',
  'Today preferred',
  'Median',
  'Slowest 10%',
  'Dash agent',
  'Answer length',
  '',
];

/** Newest version first. */
export const VersionsTable = ({versions}: {versions: AskHealthVersion[]}) => (
  <div className={styles.tableScroll}>
    <Table>
      <Table.Header>
        <Table.Row>
          {HEADERS.map((header) => (
            <Table.HeaderCell key={header} className={styles.nowrap}>
              {header}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {[...versions].reverse().map((v) => (
          <Table.Row key={v.label}>
            <Table.Cell className={styles.nowrap}>{shortDate(v.date)}</Table.Cell>
            <Table.Cell>
              <Text size="small" color="subtle">
                {v.changed ?? v.label}
                {v.model ? ` · ${v.model}` : ''}
              </Text>
            </Table.Cell>
            <Table.Cell className={styles.nowrap}>{round(offlineQuality(v))}</Table.Cell>
            <Table.Cell className={styles.nowrap}>
              {round(v.quality == null ? null : 100 * v.quality)}
            </Table.Cell>
            <Table.Cell className={styles.nowrap}>
              {v.today_preferred == null ? 'today' : percent(v.today_preferred)}
            </Table.Cell>
            <Table.Cell className={styles.nowrap}>{seconds(v.median_seconds)}</Table.Cell>
            <Table.Cell className={styles.nowrap}>{seconds(v.p90_seconds)}</Table.Cell>
            <Table.Cell className={styles.nowrap}>{percent(v.dash_agent)}</Table.Cell>
            <Table.Cell className={styles.nowrap}>
              {v.answer_chars == null ? '—' : `${v.answer_chars.toLocaleString()} chars`}
            </Table.Cell>
            <Table.Cell className={styles.nowrap}>
              {v.url ? (
                <Text size="small">
                  <Link to={v.url}>Experiment</Link>
                </Text>
              ) : null}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </div>
);
